import { isKredafiShell } from "./brand";
import { isTelegramMiniApp } from "./platform";

/** Значения совпадают с public/api/lib/deposit_client.php */
export type DepositClientChannel =
  | "telegram_mini_app"
  | "kredafi"
  | "webtransfer";

export function getDepositClientChannel(): DepositClientChannel {
  if (isTelegramMiniApp) {
    return "telegram_mini_app";
  }
  if (isKredafiShell()) {
    return "kredafi";
  }
  return "webtransfer";
}
